import { ActivatedRouteSnapshot, RedirectCommand, ResolveFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { map } from 'rxjs/operators';
import { IMenuWithPages, MenusService } from '@core';

export const pdfMenuResolver: ResolveFn<IMenuWithPages | RedirectCommand> = (
  route: ActivatedRouteSnapshot,
) => {
  const router = inject(Router);
  const menusService = inject(MenusService);
  const redirectToHome = new RedirectCommand(router.parseUrl('/main/home'));

  const menuId = route.paramMap.get('id') ? Number(route.paramMap.get('id')) : null;

  if (!menuId) {
    return redirectToHome;
  }

  return menusService.menusWithPages$.pipe(
    map((menus) => {
      const page = menus?.find((menu) => menu.id === menuId);

      if (!page) {
        return redirectToHome;
      }

      return page;
    }),
  );
};

export const pdfMenuAnimationResolver: ResolveFn<string> = (
  route: ActivatedRouteSnapshot,
) => {
  const menuId = route.paramMap.get('id');
  return `pdf-menu/${ menuId || 'unknown' }`;
};

export const pdfMenuScreenNameResolver: ResolveFn<string> = (
  route: ActivatedRouteSnapshot,
) => {
  const menusService = inject(MenusService);
  const menuId = route.paramMap.get('id') ? Number(route.paramMap.get('id')) : null;

  if (!menuId) {
    return 'Unknown Menu';
  }

  return menusService.menus$.pipe(
    map((menus) => {
      const menu = menus?.find((menu) => menu.id === menuId);

      if (!menu) {
        return 'Unknown Menu';
      }

      return menu.name;
    }),
  );
};

export const pdfMenuResolvers = {
  menu: pdfMenuResolver,
  animation: pdfMenuAnimationResolver,
  screen: pdfMenuScreenNameResolver,
};
